import { render, staticRenderFns } from "./LexonBreadcrumbsComponent.vue?vue&type=template&id=aa9ebeb8&scoped=true"
import script from "./LexonBreadcrumbsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LexonBreadcrumbsComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LexonBreadcrumbsComponent.vue?vue&type=style&index=0&id=aa9ebeb8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9ebeb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa9ebeb8')) {
      api.createRecord('aa9ebeb8', component.options)
    } else {
      api.reload('aa9ebeb8', component.options)
    }
    module.hot.accept("./LexonBreadcrumbsComponent.vue?vue&type=template&id=aa9ebeb8&scoped=true", function () {
      api.rerender('aa9ebeb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonBreadcrumbs/LexonBreadcrumbsComponent.vue"
export default component.exports